























import {Component, Vue} from "vue-property-decorator";
import api from '@/api/api'
import ShopHeader from "@/components/shop/ShopHeader.vue";
import selectByLang from "@/helpers/selectByLang";

@Component({
  components: {
    ShopHeader
  }
})
export default class Shop extends Vue {
  public img = 'storeHeader.png'
  public navigation = [] as any[]
  public selectByLang(optionCn, optionEn) {
    return selectByLang(optionCn, optionEn)
  }

  get lang(){
    return this.$store.getters.locale
  }

  get storeId(){
    return this.$route.params.shopId
  }

  async created(){
    console.table('storeId', this.storeId)
    try{
      const resp = await api.getStorehomeNav(this.storeId)
      this.navigation = resp.data
    }catch (e){
      console.log(e)
    }
  }

}
